export default __webpack_public_path__ + "static/media/a011-general2024-example2.739c0e2f.png";